<template lang="pug">
.review-page-setup-preview
  preview(backgroundColor="neutral100")
    //- Email subject
    preview-item.mb-12.mt-0(:title="$t('email_setup_preview_subject_title')")
      preview-iphone.mt-4
        //- Email navbar
        preview-iphone-email-navbar.my-4
        .ml-2.my-4
          //- Subject line
          .h6.text-left.mb-2(v-if="subjectLine") {{ subjectLine }}
          //- Sending info
          .d-flex.align-center.justify-space-between.my-4
            .d-flex
              v-avatar(size="30" color="zooPurple")
                span.white--text Y
              .ml-4
                .d-flex.mb-1
                  .text-xs.font-semibold.mr-1 Yezza Team
                  .text-xxs 5 days ago
                .d-flex.align-center
                  .text-xs.mr-1 to me
                  v-icon(size="13") mdi-chevron-down
            .d-flex
              v-icon.mr-3(size="15" color="basic700") $yzi-ios-safari-reply-arrow
              v-icon(size="15" color="basic700") mdi-dots-vertical
          //- Body
          v-skeleton-loader.mb-4(boilerplate type="heading")
          v-skeleton-loader(boilerplate type="sentences")
    //- Notification
    preview-item(:title="$t('email_setup_preview_notification_title')")
      preview-iphone-notification.mt-4(:title="company.name" :content="notificationPreviewLine" elapsed="36m")
</template>

<script>
import { mapGetters } from 'vuex'
import Preview from '@/components/review/preview/Preview.vue'
import PreviewItem from '@/components/review/preview/PreviewItem.vue'
import PreviewIphone from '@/components/review/preview/PreviewIphone.vue'
import PreviewIphoneEmailNavbar from '@/components/review/preview/PreviewIphoneEmailNavbar.vue'
import PreviewIphoneNotification from '@/components/review/preview/PreviewIphoneNotification.vue'

export default {
  name: 'EmailSetupPreview',
  components: {
    Preview, PreviewItem, PreviewIphone, PreviewIphoneEmailNavbar, PreviewIphoneNotification
  },
  props: {
    subjectLine: {
      type: String,
      default: null
    },
    notificationPreviewLine: {
      type: String,
      default: null
    },
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
}
</script>

<style scoped>
</style>